module.exports = __webpack_public_path__ + "static/img/zhiwu.c9ac5e96.svg";